<template>
  <div ref="app" class="app-container" >
    <!-- 顶部导航 -->
    <div class="navbar bg-dark" >
      <img :src="logoUrl" height="35px" style="object-fit: contain;padding:10px;margin-right: 100px;"/>
      <el-menu :default-active="activeItem" class="bg-dark" mode="horizontal"
                text-color="#c8c9cc" active-text-color="#ffd04b" router>
        <el-menu-item index="/main" >主页</el-menu-item>
        <el-menu-item index="/product" >产品中心</el-menu-item>
        <el-menu-item index="/invite" >加入我们</el-menu-item>
        <el-menu-item index="/about">关于我们</el-menu-item>
        <el-menu-item index="/service" >服务与支持</el-menu-item>
      </el-menu>
      <div style="width: 150px;"></div>
    </div>
    <!-- 右侧导航 -->
    <div class="rightbar">
      <div class="rightbar-item" @click="toTop">
        <to-top theme="outline" size="18" fill="#f7f8fa"/>
      </div>
      <div class="rightbar-item" @mouseover="showPhone = true" @mouseout="showPhone = false">
         <phone-call theme="outline" size="18" fill="#f2f3f5"/>
         <transition name="moveR">
          <p v-show="showPhone">15710118988</p>
         </transition>
      </div>
      <div class="rightbar-item"  @mouseover="showQrcode = true" @mouseout="showQrcode = false">
        <two-dimensional-code theme="outline" size="18" fill="#ebedf0"/>
        <el-collapse-transition>
          <img v-show="showQrcode" :src="tr_qrcode" width="150px"/>
        </el-collapse-transition>
      </div>
    </div>
    <!-- 内容区 -->
    <div class="content">
      <transition name="fade-transform" mode="out-in">
        <keep-alive>
          <router-view :key="key" />
        </keep-alive>
      </transition>
    </div>
    <!-- 底部导航 -->
    <div class="footer bg-dark">
      <div class="footer-inner">
        <div class="footer-col footer-products">
          <p class="footer-title">产品中心</p>
          <div class="footer-divider"></div>
          <div class="footer-products-cols">
            <div class="footer-products-left">
              <div class="product-group">
                <router-link to="/product?type=data" class="group-title">数据平台及报表可视化</router-link>
                <router-link to="/product?type=data&sub=数据仓库系统" class="group-sub">数据仓库系统</router-link>
                <router-link to="/product?type=data&sub=报表平台及数据可视化系统" class="group-sub">报表平台及数据可视化系统</router-link>
              </div>
              <div class="product-group">
                <router-link to="/product?type=crm" class="group-title">客户管理及精准营销</router-link>
                <router-link to="/product?type=crm&sub=外呼营销管理系统" class="group-sub">外呼营销管理系统</router-link>
                <router-link to="/product?type=crm&sub=营销管理系统" class="group-sub">营销管理系统</router-link>
                <router-link to="/product?type=crm&sub=私域营销系统" class="group-sub">私域营销系统</router-link>
                <router-link to="/product?type=crm&sub=厅堂营销系统" class="group-sub">厅堂营销系统</router-link>
                <router-link to="/product?type=crm&sub=客户分层分类及精准营销系统" class="group-sub">客户分层分类及精准营销系统</router-link>
                <router-link to="/product?type=crm&sub=普惠走访及网格化管理系统" class="group-sub">普惠走访及网格化管理系统</router-link>
                <router-link to="/product?type=crm&sub=商户营销管理系统" class="group-sub">商户营销管理系统</router-link>
                <router-link to="/product?type=crm&sub=企业管理平台（对公客户管理）" class="group-sub">企业管理平台（对公客户管理）</router-link>
                <router-link to="/product?type=crm&sub=客群管理系统" class="group-sub">客群管理系统</router-link>
                <router-link to="/product?type=crm&sub=客户权益系统" class="group-sub">客户权益系统</router-link>
              </div>
              <div class="product-group">
                <router-link to="/product?type=hr" class="group-title">人力资源及绩效考核管理</router-link>
                <router-link to="/product?type=hr&sub=人力资源管理系统" class="group-sub">人力资源管理系统</router-link>
                <router-link to="/product?type=hr&sub=员工行为管理系统" class="group-sub">员工行为管理系统</router-link>
                <router-link to="/product?type=hr&sub=绩效考核管理系统" class="group-sub">绩效考核管理系统</router-link>
              </div>
            </div>
            <div class="footer-products-right">
              <div class="product-group">
                <router-link to="/product?type=credit" class="group-title">信贷全流程管理</router-link>
                <router-link to="/product?type=credit&sub=贷前管理系统" class="group-sub">贷前管理系统</router-link>
                <router-link to="/product?type=credit&sub=贷后管理系统" class="group-sub">贷后管理系统</router-link>
                <router-link to="/product?type=credit&sub=不良管理系统" class="group-sub">不良管理系统</router-link>
                <router-link to="/product?type=credit&sub=信贷档案管理系统" class="group-sub">信贷档案管理系统</router-link>
                <router-link to="/product?type=credit&sub=贷款责任制管理系统" class="group-sub">贷款责任制管理系统</router-link>
              </div>
              <div class="product-group">
                <router-link to="/product?type=workflow" class="group-title">流程优化及内部管理</router-link>
                <router-link to="/product?type=workflow&sub=数智办公管理系统" class="group-sub">数智办公管理系统</router-link>
                <router-link to="/product?type=workflow&sub=预算费用管理系统" class="group-sub">预算费用管理系统</router-link>
                <router-link to="/product?type=workflow&sub=科技管理系统" class="group-sub">科技管理系统</router-link>
                <router-link to="/product?type=workflow&sub=物资管理系统" class="group-sub">物资管理系统</router-link>
                <router-link to="/product?type=workflow&sub=PMO管理系统" class="group-sub">PMO管理系统</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-col">
          <p class="footer-title">关于同儒</p>
          <div class="footer-divider"></div>
          <router-link to="/about"><span>公司介绍</span></router-link>
          <router-link to="/service"><span>服务与支持</span></router-link>
          <router-link to="/invite"><span>加入我们</span></router-link>
        </div>
        <div class="footer-contact">
          <p class="footer-title">联系我们</p>
          <div class="footer-divider"></div>
          <p class="contact-phone">15710118988</p>
          <p class="contact-label">服务热线</p>
          <div class="footer-divider" style="width: 100%;"></div>
          <p class="contact-label">关注我们</p>
          <img :src="tr_qrcode" width="100px"/>
        </div>
      </div> 
    </div>
    <div class="copyright bg-dark">
      Copyright © 上海同儒信息技术有限公司  沪ICP备19044649号
    </div>
  </div>
</template>

<script>
  import { ToTop, PhoneCall, TwoDimensionalCode } from '@icon-park/vue'
  import { initWxShare } from '@/utils/wechatShare'

  export default {
    components: { ToTop, PhoneCall, TwoDimensionalCode },
    name: 'app',
    data () {
      return {
        activeItem: "/main",
        transName: 'van-slide-left',
        logoUrl: require('@/assets/logo_white.png'),
        tr_qrcode: require('@/assets/tr_qrcode.jpg'),
        showPhone: false,
        showQrcode: false
      }
    },
    computed: {
      key() {
        return this.$route.path
      }
    },
    watch: {
      $route(to,from){
        this.activeItem = to.path
        this.toTop()
      }
    },
    created() {
      this.activeItem = this.$route.path
    },
    mounted() {
      initWxShare({
        title: '上海同儒信息技术有限公司',
        desc: '国内专业的银行金融IT解决方案供应商，专注于金融行业软件产品的研发与实施',
        link: window.location.href,
        imgUrl: window.location.origin + require('@/assets/logo_white.png')
      })
    },
    methods: {
      toTop() {
        var that = this
        let timer = setInterval(() => {
          let ispeed = Math.floor(-that.$refs.app.scrollTop / 5)
          that.$refs.app.scrollTop = that.$refs.app.scrollTop + ispeed
          if (that.$refs.app.scrollTop === 0) {
            clearInterval(timer)
          }
        }, 16)
      }
    }
  }
  
</script>

<style lang="less" scoped>
  
  .moveR-enter-active,  .moveR-leave-active {
    transition: all 0.3s linear;
    transform: translateX(0);
  }
   .moveR-enter,  .moveR-leave {
    transform: translateX(100%);
  }
   .moveR-leave-to{
     transform: translateX(100%);
   }
  
  .app-container {
    overflow-y: scroll;
  }
  
  .bg-dark {
    background: linear-gradient(135deg, #0d1421 0%, #151d2e 40%, #1a2438 100%);
  }
  
  .content {
    
  }

  .navbar {
    position: sticky;
    top: 0;
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    backdrop-filter: blur(12px);
    background: linear-gradient(135deg, rgba(13, 20, 33, 0.96) 0%, rgba(21, 29, 46, 0.96) 40%, rgba(26, 36, 56, 0.96) 100%);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    box-shadow: 0 4px 28px rgba(0, 0, 0, 0.25);
    
    .el-menu-item {
      font-size: 15px;
      height: auto;
      margin: 0 4px;
      border-radius: 20px;
      transition: all 0.3s ease;
      letter-spacing: 0.5px;

      &:hover {
        background: rgba(255, 255, 255, 0.08) !important;
        color: #ffd04b !important;
      }

      &.is-active {
        background: rgba(255, 255, 255, 0.1) !important;
        color: #ffd04b !important;
      }
    }
  }
  
  .rightbar {
    position: fixed;
    top: 50%;
    right: 16px;
    z-index: 99;
    transform: translateY(-50%);
    
    .rightbar-item {
      position: relative;
      padding: 12px;
      margin: 4px 0;
      border-radius: 10px;
      background: rgba(47, 125, 205, 0.8);
      cursor: pointer;
      transition: all 0.3s ease;
      backdrop-filter: blur(8px);
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      
      p {
        position: absolute;
        top: 50%;
        right: calc(100% + 8px);
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #2F7DCD 0%, #1a56b8 100%);
        color: #fff;
        overflow: visible;
        width: 10em;
        border-radius: 8px;
        padding: 8px 12px;
        font-size: 13px;
        white-space: nowrap;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        pointer-events: none;
      }
      
      img {
        position: absolute;
        bottom: -10px;
        right: calc(100% + 8px);
        border-radius: 8px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
      }
    }
    
    .rightbar-item:hover {
      background: linear-gradient(135deg, #1a56b8 0%, #174291 100%);
      transform: scale(1.08);
      box-shadow: 0 4px 20px rgba(47, 125, 205, 0.4);
    }
  }
  
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  .el-menu-item {
    padding: 0 36px;
    background: transparent !important;
    color: #c8c9cc !important;
    transition: all 0.3s ease;
  }
  .el-menu-item:hover {
    color: #ffd04b !important;
  }
  .el-menu-item.is-active {
    color: #ffd04b !important;
  }
  
  .footer {
    padding: 60px 0 40px;
    color: #fff;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 8%;
      right: 8%;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent);
    }

    .footer-inner {
      display: flex;
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 40px;
      gap: 40px;
    }

    .footer-col {
      flex: 1;

      .footer-title {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 0;
        letter-spacing: 1px;
        color: #fff;
      }

      .footer-divider {
        width: 32px;
        height: 2px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 1px;
        margin: 14px 0 18px;
      }

      a {
        display: block;
        text-decoration: none;
        padding: 6px 0;
      }

      span {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.55);
        transition: all 0.25s ease;
        position: relative;
        padding-left: 0;
        transition: all 0.25s ease;
      }

      a:hover span {
        color: #ffd04b;
        padding-left: 6px;
      }
    }

    .footer-products {
      flex: 2;

      .footer-products-cols {
        display: flex;
        gap: 40px;
      }

      .footer-products-left,
      .footer-products-right {
        flex: 1;
        min-width: 0;
      }

      .product-group {
        margin-bottom: 14px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .group-title {
        display: block;
        text-decoration: none;
        padding: 5px 0 4px 0;
        font-size: 14px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.85);
        transition: all 0.25s ease;

        &:hover {
          color: #ffd04b;
        }
      }

      .group-sub {
        display: block;
        text-decoration: none;
        padding: 3px 0 3px 14px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.4);
        transition: all 0.25s ease;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &::before {
          content: '';
          position: absolute;
          left: 4px;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 4px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
        }

        &:hover {
          color: rgba(255, 255, 255, 0.75);
          padding-left: 18px;

          &::before {
            background: #ffd04b;
          }
        }
      }
    }

    .footer-contact {
      flex: 0.8;
      margin-left: 40px;

      .footer-title {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 0;
        letter-spacing: 1px;
        color: #fff;
      }

      .footer-divider {
        width: 32px;
        height: 2px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 1px;
        margin: 14px 0 18px;
      }

      .contact-phone {
        font-size: 22px;
        font-weight: 700;
        color: #ffd04b;
        margin: 0 0 4px 0;
        letter-spacing: 1px;
      }

      .contact-label {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.45);
        margin: 0 0 16px 0;
      }

      img {
        border-radius: 8px;
        margin-top: 8px;
      }
    }
  }
  
  .copyright {
    padding: 16px;
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
    font-size: 13px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    letter-spacing: 0.5px;
  }

  @media (max-width: 768px) {
    .footer .footer-inner {
      flex-wrap: wrap;
      gap: 32px;
      padding: 0 20px;
    }

    .footer .footer-col,
    .footer .footer-contact {
      flex: 1 1 40%;
      min-width: 140px;
      margin-left: 0;
    }
  }

  @media (max-width: 480px) {
    .footer .footer-inner {
      flex-direction: column;
      gap: 30px;
    }

    .footer .footer-col,
    .footer .footer-contact {
      flex: 1 1 100%;
    }
  }
</style>